// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.delete-member-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1100;
}

.delete-member-modal {
  background: white;
  border-radius: 8px;
  padding: 2rem;
  max-width: 520px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  box-sizing: border-box;
}

.delete-member-modal__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  border-bottom: 1px solid #e0e0e0;
  padding-bottom: 1rem;
}

.delete-member-modal__header h2 {
  margin: 0;
  font-size: 1.25rem;
  color: #333;
}

.delete-member-modal__close {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.delete-member-modal__close:hover {
  background-color: #f0f0f0;
}

.delete-member-modal__body {
  margin-bottom: 1.5rem;
}

.delete-member-modal__deps {
  background: #fff8f0;
  border: 1px solid #f97316;
  border-radius: 6px;
  padding: 1rem;
  margin-bottom: 1.25rem;
}

.delete-member-modal__deps p {
  margin: 0 0 0.75rem 0;
  font-weight: 500;
  color: #92400e;
}

.delete-member-modal__deps ul {
  margin: 0;
  padding-left: 1.25rem;
  color: #374151;
}

.delete-member-modal__deps ul li {
  margin-bottom: 0.25rem;
}

.delete-member-modal__select-group {
  margin-bottom: 1rem;
}

.delete-member-modal__select-group label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  color: #333;
}

.delete-member-modal__select-group select {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
  box-sizing: border-box;
  transition: border-color 0.2s;
}

.delete-member-modal__select-group select:focus {
  outline: none;
  border-color: #f97316;
}

.delete-member-modal__confirm-text {
  color: #374151;
  margin: 0 0 0.5rem 0;
}

.delete-member-modal__confirm-text strong {
  color: #111827;
}

.delete-member-modal__error {
  color: #dc3545;
  font-size: 0.875rem;
  margin-top: 0.5rem;
}

.delete-member-modal__actions {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  border-top: 1px solid #e0e0e0;
  padding-top: 1rem;
}
`, "",{"version":3,"sources":["webpack://./src/composants/DeleteMemberModal/DeleteMemberModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,6BAA6B;EAC7B,iBAAiB;AACnB","sourcesContent":[".delete-member-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1100;\n}\n\n.delete-member-modal {\n  background: white;\n  border-radius: 8px;\n  padding: 2rem;\n  max-width: 520px;\n  width: 90%;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-sizing: border-box;\n}\n\n.delete-member-modal__header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1.5rem;\n  border-bottom: 1px solid #e0e0e0;\n  padding-bottom: 1rem;\n}\n\n.delete-member-modal__header h2 {\n  margin: 0;\n  font-size: 1.25rem;\n  color: #333;\n}\n\n.delete-member-modal__close {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0.5rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  transition: background-color 0.2s;\n}\n\n.delete-member-modal__close:hover {\n  background-color: #f0f0f0;\n}\n\n.delete-member-modal__body {\n  margin-bottom: 1.5rem;\n}\n\n.delete-member-modal__deps {\n  background: #fff8f0;\n  border: 1px solid #f97316;\n  border-radius: 6px;\n  padding: 1rem;\n  margin-bottom: 1.25rem;\n}\n\n.delete-member-modal__deps p {\n  margin: 0 0 0.75rem 0;\n  font-weight: 500;\n  color: #92400e;\n}\n\n.delete-member-modal__deps ul {\n  margin: 0;\n  padding-left: 1.25rem;\n  color: #374151;\n}\n\n.delete-member-modal__deps ul li {\n  margin-bottom: 0.25rem;\n}\n\n.delete-member-modal__select-group {\n  margin-bottom: 1rem;\n}\n\n.delete-member-modal__select-group label {\n  display: block;\n  margin-bottom: 0.5rem;\n  font-weight: 500;\n  color: #333;\n}\n\n.delete-member-modal__select-group select {\n  width: 100%;\n  padding: 0.75rem;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 1rem;\n  box-sizing: border-box;\n  transition: border-color 0.2s;\n}\n\n.delete-member-modal__select-group select:focus {\n  outline: none;\n  border-color: #f97316;\n}\n\n.delete-member-modal__confirm-text {\n  color: #374151;\n  margin: 0 0 0.5rem 0;\n}\n\n.delete-member-modal__confirm-text strong {\n  color: #111827;\n}\n\n.delete-member-modal__error {\n  color: #dc3545;\n  font-size: 0.875rem;\n  margin-top: 0.5rem;\n}\n\n.delete-member-modal__actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 1rem;\n  border-top: 1px solid #e0e0e0;\n  padding-top: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
